import { Animal } from './animal.model';

export class PurchaseOrderAnimal {
  animal?: Animal;
  animal_id?: number;
  color_correct?: boolean;
  gender_correct?: boolean;
  id?: number;
  price: string;
  price_ex_vat?: string;
  purchase_order_id?: number;
  weight: number;
  weight_correct?: boolean;
  created_at?: string;
}

export class PurchaseOrderAnimalCustom {
  country_code: string;
  identification_number: string;
  weight?: number;
  price?: number;
  price_ex_vat?: number;
  weight_correct: boolean;
  is_healthy: boolean;
  gender_id: number;
  color_id: number;
  date_of_birth?: string;
  date_of_birth_mutation?: string;
  work_number?: string;

  constructor(
    animal?: Partial<PurchaseOrderAnimalCustom>
  ) {
    this.country_code = animal?.country_code;
    this.identification_number = animal?.identification_number;
    this.weight = animal?.weight ?? 0;
    this.price = animal?.price ?? 0;
    this.price_ex_vat = animal?.price_ex_vat ?? null;
    this.weight_correct = animal?.weight_correct ?? true;
    this.is_healthy = animal?.is_healthy ?? true;
    this.gender_id = animal?.gender_id ?? null;
    this.color_id = animal?.color_id ?? null;
    this.date_of_birth = animal?.date_of_birth ?? null;
    this.date_of_birth_mutation = animal?.date_of_birth_mutation ?? null;
    this.work_number = animal?.work_number ?? null;
  }

}
